import { create } from "zustand";
import { devtools } from "zustand/middleware";
const useToggleStore = create(
	devtools((set) => ({
		isToggleQR: false,
		setIsToggleQR: (isToggleQR: boolean) => set({ isToggleQR: isToggleQR }),
		isToggleAutoLogin: false,
		setIsToggleAutoLogin: (isToggleAutoLogin: boolean) => set({ isToggleAutoLogin: isToggleAutoLogin }),
		isToggleMQTT: false,
		setIsToggleMQTT: (isToggleMQTT: boolean) => set({ isToggleMQTT: isToggleMQTT }),
		isToggleAdvanceSettings: false,
		setIsToggleAdvanceSettings: (isToggleAdvanceSettings: boolean) => set({ isToggleAdvanceSettings: isToggleAdvanceSettings }),
		isToggleBehindTheScene: false,
		setIsToggleBehindTheScene: (isToggleBehindTheScene: boolean) => set({ isToggleBehindTheScene: isToggleBehindTheScene }),
		isToggleSKLegals: false,
		setIsToggleSKLegals: (isToggleSKLegals: boolean) => set({ isToggleSKLegals: isToggleSKLegals }),
		isToggleHideDataMgmt: false,
		setIsToggleHideDataMgmt: (isToggleHideDataMgmt: boolean) => set({ isToggleHideDataMgmt: isToggleHideDataMgmt }),
		isShimmerLoading: false,
		setIsShimmerLoading: (isShimmerLoading: boolean) => set({ isShimmerLoading: isShimmerLoading }),
		isMqttMessageAckEnabled: false,
		setIsMqttMessageAckEnabled: (isMqttMessageAckEnabled: boolean) => set({ isMqttMessageAckEnabled: isMqttMessageAckEnabled }),
	})),
);
export default useToggleStore;
